import { render, staticRenderFns } from "./orders-list.vue?vue&type=template&id=57ea49a6&scoped=true"
import script from "./orders-list.vue?vue&type=script&lang=js"
export * from "./orders-list.vue?vue&type=script&lang=js"
import style0 from "./orders-list.vue?vue&type=style&index=0&id=57ea49a6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ea49a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gobo-app/gobo-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57ea49a6')) {
      api.createRecord('57ea49a6', component.options)
    } else {
      api.reload('57ea49a6', component.options)
    }
    module.hot.accept("./orders-list.vue?vue&type=template&id=57ea49a6&scoped=true", function () {
      api.rerender('57ea49a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/orders-list.vue"
export default component.exports